import { FileTextFilled } from '@ant-design/icons'
import EditFilled from '@ant-design/icons/lib/icons/EditFilled'
import Flex from 'antd/lib/flex'
import MarkdownRenderer from 'Components/common/MarkdownRenderer/MarkdownRenderer'
import { getFileDownloadUrl } from 'Services/tasks.service'
import { downloadPublicFile } from 'Utils/common.utils'

type UserContentPropsType = {
    prompt: string
    urls: string[]
    onClickEditContent?: () => void
    isEditAllowed: boolean
}

export const UserContent = (props: UserContentPropsType) => {
    const { prompt, urls, onClickEditContent, isEditAllowed } = props

    const getFileName = (path: string) => {
        return path.split('/').pop() ?? ''
    }

    const downloadFile = async (path: string) => {
        const downloadUrl = await getFileDownloadUrl(path)
        if (downloadUrl) {
            downloadPublicFile(downloadUrl)
        }
    }

    return (
        <>
            <div className={'conversation-message'}>
                <MarkdownRenderer children={prompt} escapeBackslashses={true} />

                <div className="media-files-container">
                    {urls?.map((url: string) => (
                        <div
                            key={url}
                            className="file-item"
                            onClick={() => downloadFile(url)}
                            onKeyDown={e => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault()
                                    downloadFile(url)
                                }
                            }}
                            tabIndex={0}
                            role="button"
                            aria-label={`Download file ${getFileName(url)}`}
                        >
                            <FileTextFilled className="file-icon" />
                            {getFileName(url)}
                        </div>
                    ))}
                </div>
            </div>
            {isEditAllowed && (
                <Flex
                    className="edit-container"
                    gap={5}
                    onClick={onClickEditContent}
                    onKeyDown={e => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault()
                            onClickEditContent?.()
                        }
                    }}
                    tabIndex={0}
                    role="button"
                    aria-label="Edit content"
                >
                    <EditFilled className="edit-icon" />
                </Flex>
            )}
        </>
    )
}
